﻿import React from 'react';
import DatePicker from "react-datepicker";
import { str_isEmpty } from '@Util/Utils';
import { Datepicker_With_Label_Props } from '@Util/Types';

export default function Datepicker_With_Label(props: Datepicker_With_Label_Props): JSX.Element {

    function generate_element_class(): string {
        let class_str: string = "Form_Row";

        if (!str_isEmpty(props?.className)) {
            class_str += ` ${props.className}`;
        }

        if (props.error) {
            class_str += " Form_Row--Error";
        }

        return class_str;
    }

    const date_format: string = props?.disableTime ? "yyyy-MM-dd" : "yyyy-MM-dd - HH:mm";

    return (
        <div className={generate_element_class()}>
            {
                !str_isEmpty(props.label) &&
                <label htmlFor={props.id}>{props.label}</label>
            }
            <DatePicker
                name={props.id}
                id={props.id}
                selected={new Date(props?.selected)}
                onChange={props?.onChange}
                showTimeInput={props?.disableTime ? false : true}
                timeInputLabel="Tid:"
                timeFormat="HH:mm"
                locale="sv"
                calendarStartDay={1}
                className="Form_Input"
                dateFormat={date_format}
                maxDate={props?.maxDate ?? undefined}
                minDate={props?.minDate ?? undefined}
            />
        </div>
    )
}